import {FC, useEffect, useState} from 'react'
import {Button} from '../../../components/Button/Button'
import {Input} from '../../../components/Input/Input'
import {Loading} from '../../../components/Loading/Loading'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {i18n} from '../../../translate/i18n'
import {useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import {GET, POST, PUT} from '../../../services/api'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../hooks/useModals'

const SegurancaMesa: FC<any> = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [locationRadius, setLocationRadius] = useState(0)
  const [id, setId] = useState(0)
  const [accessMaximus, setAccessMaximus] = useState(0)
  const [limitTime, setLimitTime] = useState(0)
  const [password, setPassword] = useState('')

  const [tableNumber, setTableNumber] = useState('')
  const [typeDevice, setTypeDevice] = useState('')

  const {showWrapperModal} = useModals()

  async function getSecurityConfig() {
    try {
      setLoading(true)

      const getResponse = await GET('security-config')

      if (getResponse && getResponse.success) {
        const {id, locationRadius, accessMaximus, limitTime, password} = getResponse.data
        setId(id)
        setLocationRadius(locationRadius)
        setAccessMaximus(accessMaximus)
        setLimitTime(limitTime)
        setPassword(password)
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Um erro aconteceu',
      })
    }
  }

  async function create() {
    try {
      setLoading(true)

      const getResponse = await POST('security-config', {
        locationRadius,
        accessMaximus,
        limitTime,
        password,
      })

      if (getResponse && getResponse.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: 'Configurção criada com sucesso',
        }).then(() => navigate('/webapp'))
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Um erro aconteceu',
        })
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Um erro aconteceu',
      })
    }
  }

  async function update() {
    try {
      setLoading(true)

      const getResponse = await PUT(`security-config/${id}`, {
        locationRadius,
        accessMaximus,
        limitTime,
        password,
      })

      if (getResponse && getResponse.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: 'Configurção editada com sucesso',
        }).then(() => navigate('/webapp'))
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Um erro aconteceu',
        })
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Um erro aconteceu',
      })
    }
  }

  async function clearTableCard() {
    try {
      if (!tableNumber || !typeDevice) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Falta campos a serem inseridos',
        })
        return
      }
      setLoading(true)

      const responseDelete = await POST('table-device/delete', {
        tableNumber: tableNumber,
        typeDevice: typeDevice,
      })

      setLoading(false)

      setTableNumber('')
      if (!responseDelete || !responseDelete.success) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: responseDelete.message ? responseDelete.message : 'Um erro inesperado aconteceu',
        })
        return
      }

      Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: 'Mesa/Comanda liberada com sucesso',
      })
      return
    } catch (error) {
      setLoading(false)
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Um erro inesperado aconteceu',
      })
    }
  }

  useEffect(() => {
    getSecurityConfig()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row  gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`webapp.security_settings`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`general.save_changes_edit`)}
                </span>
              </h3>
              <div>
                <Button
                  text={i18n.t(`buttons.clear_table_card`)}
                  color='primary'
                  size='small'
                  horizontalPadding={5}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    showWrapperModal('Limpar mesa ou comanda')
                  }}
                  btnClass='fw-bolder me-3'
                />
              </div>
            </div>
            <div className='card-body border-bottom'>
              <div className='col-4'>
                <Input
                  inputAttr={{
                    type: 'number',
                  }}
                  label={i18n.t(`webapp.maximus_radius`)}
                  value={locationRadius}
                  change={(value: number) => {
                    setLocationRadius(value)
                  }}
                  minNumber={0}
                />
              </div>
              <div className='col-4'>
                <Input
                  inputAttr={{
                    type: 'number',
                  }}
                  label={i18n.t(`webapp.access_maximus`)}
                  value={accessMaximus}
                  change={(value: number) => {
                    setAccessMaximus(value)
                  }}
                  minNumber={0}
                />
              </div>
              <div className='col-4'>
                <Input
                  inputAttr={{
                    type: 'number',
                  }}
                  label={i18n.t(`webapp.limit_time`)}
                  value={limitTime}
                  change={(value: number) => {
                    setLimitTime(value)
                  }}
                  minNumber={0}
                />
              </div>
              <div className='col-4'>
                <Input
                  inputAttr={{
                    type: 'default',
                  }}
                  label={i18n.t(`webapp.password`)}
                  value={password}
                  change={(value: string) => {
                    setPassword(value)
                  }}
                  maxCaracteres={6}
                />
              </div>
            </div>
            <div className='d-flex justify-content-end'>
              {/* <Button
                text={i18n.t(`buttons.back`)}
                color='info'
                size='small'
                horizontalPadding={5}
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  navigate('/webapp')
                }}
                btnClass='fw-bolder m-9'
              /> */}

              <Button
                text={i18n.t(`buttons.save`)}
                color='primary'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  id ? update() : create()
                }}
                btnClass='fw-bolder m-9'
              />
            </div>
          </div>

          <ModalWrapper
            confirmAction={() => {
              clearTableCard()
            }}
          >
            <div className='d-flex flex-column  gap-5 py-2'>
              <span>
                Utilize este comando para limpar todos os acessos de uma mesa ou comanda. Todos os
                aparelhos serão desconectados.
              </span>

              <div>
                <Input
                  inputAttr={{
                    type: 'newRadioModal',
                  }}
                  label='Mesa'
                  name='tipo'
                  value={'table'}
                  change={(value: any) => {
                    setTypeDevice(value)
                  }}
                />

                <Input
                  inputAttr={{
                    type: 'newRadioModal',
                  }}
                  name='tipo'
                  label='Comanda'
                  value={'card'}
                  change={(value: any) => {
                    setTypeDevice(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'number',
                  }}
                  label='Número'
                  value={tableNumber}
                  minNumber={0}
                  change={(value: any) => {
                    setTableNumber(value)
                  }}
                />
              </div>
            </div>
          </ModalWrapper>
        </div>
      )}
    </>
  )
}

export {SegurancaMesa}
